module.exports = __webpack_public_path__ + "static/img/case_detail_03_5.2cb6f78.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/case/case_detail_03_5.png
// module id = 9E52
// module chunks = 34